import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import Footer from "../components/Footer";

export default function About({ isPage = true }) {
  const navigate = useNavigate();

  const fullText = `സെന്റ് ജോർജ്ജ് യൂത്ത് അസോസിയേഷൻ ചേലക്കര, യാക്കോബായ സിറിയൻ ഓർത്തഡോക്സ് യൂത്ത് അസോസിയേഷന്റെ ഭാഗമായി ചേലക്കര സെന്റ് ജോർജ്ജ് യാക്കോബായ സുറിയാനി പള്ളിക്ക് കീഴിൽ പ്രവർത്തിക്കുന്ന ആത്മീയ സംഘടനയാണ്. യുവാക്കൾ നമ്മുടെ കർത്താവായ യേശുക്രിസ്തുവിന്റെ ഹൃദയത്തോട് വളരെ അടുത്തവരാണ് ."യഹോവ ഭക്തി ജ്ഞാനത്തിന്റെ ആരംഭവും; പരിശുദ്ധനെക്കുറിച്ചുള്ള പരിജ്ഞാനം വിവേകമാകുന്നു." സാദൃശ്യവാക്യങ്ങൾ 9:10,11

യാക്കോബായ സുറിയാനി സഭയുടെ വിശ്വാസം, പാരമ്പര്യങ്ങൾ, ആരാധന എന്നിവ വരും തലമുറയിൽ ഉയർത്തിപ്പിടിക്കുന്നുവെന്ന് ഉറപ്പാക്കാനും , പ്രധാനമായും ഇന്നത്തെ ആധുനിക സാമൂഹിക പരിതസ്ഥിതിയിൽ , ഇന്നത്തെ യുവാക്കൾ അഭിമുഖീകരിക്കുന്ന പ്രശ്നങ്ങൾ മനസിലാക്കാനും അറിയാനും നാം വളരെയധികം പരിശ്രമിക്കേണ്ടതുണ്ട്. ഇന്ന് യുവാക്കളുടെ പ്രശ്നങ്ങളും പ്രതിസന്ധികളും യൂത്ത് അസോസിയേഷൻ സജീവമായി അഭിസംബോധന ചെയ്യുന്നു. അവരുടെ കാഴ്ചപ്പാടുകളും അഭിപ്രായങ്ങളും ഉൾക്കൊള്ളുക എന്നതാണ് അസോസിയേഷന്റെ മൂലക്കല്ല്.

പരിശുദ്ധ സഭയുടെ പാരമ്പര്യത്തിലും വിശ്വാസത്തിലും, സമൂഹത്തോടുള്ള പ്രിബദ്ധതയിലും മുന്നോട്ട് പോകുന്നതിനോട് ഒപ്പം തന്നെ ഈ സംഘടന നിരവധി ചാരിറ്റി പ്രവർത്തനങ്ങൾക്ക് നേതൃത്വം നൽകിവരുന്നു. സമൂഹത്തിൽ സാമ്പത്തികമായി പിന്നോക്കം നിൽക്കുന്ന വിദ്യാർത്ഥികൾക്ക് ഈ സംഘടന പഠനോപകരണങ്ങൾ വിതരണം ചെയുന്നു.  ചാരിറ്റി പ്രവർത്തനങ്ങളുടെ ഭാഗമായി 100 ഡയാലിസിസ് നടത്തുവാൻ ദൈവകൃപയാൽ സാധിച്ചു.ഈ വർഷം യൂത്ത് അസോസിയേഷന്റെ 25-ാം വാർഷികമാണ് അതിനോടനുബന്ധിച്ച് ഒരു വർഷം നീണ്ടുനിൽക്കുന്ന വിവിധ പരിപാടികൾ ക്രമീകരിച്ചിട്ടുണ്ടു. കൂടാതെ ഇടവകയുടെ ആത്മീയവും ഭൗതികവുമായ കാര്യങ്ങളിൽ സെൻ്റ് ജോർജ് യൂത്ത് അസോസിയേഷൻ നിരന്തരം പ്രവർത്തിച്ചുകൊണ്ടിരിക്കുന്നു.`;

  const [images, setImages] = useState([]);
  const [current, setCurrent] = useState(0);
  const [loading, setLoading] = useState(true);

  const API = process.env.PARCEL_API_URL || "http://localhost:5000";

  // 🔥 Fetch images
  useEffect(() => {
    fetch(`${API}/api/about`)
      .then((res) => res.json())
      .then((data) => setImages(data.images || []))
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  }, [API]);

  // 🔥 Auto slider
  useEffect(() => {
    if (images.length === 0) return;

    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [images]);

  return (
    <div
      className={`bg-orange-50 flex flex-col ${isPage ? "min-h-screen" : ""}`}
    >
      <section className="px-4 sm:px-6 md:px-16 lg:px-24 py-8 md:py-10 flex-grow">
        {/* 🔙 Back Button */}
        {isPage && (
          <button
            onClick={() => navigate("/")}
            className="mb-6 text-orange-500 font-semibold hover:underline"
          >
            ← Back to Home
          </button>
        )}

        {/* 🔥 Title */}
        <h2 className="text-2xl sm:text-3xl font-bold text-center mb-8">
          About <span className="text-orange-500">Us</span>
        </h2>

        {/* 🔥 TEXT */}
        {loading ? (
          // 🔥 TEXT SKELETON
          <div className="space-y-3 mb-10">
            <div className="h-4 bg-gray-300 rounded w-full animate-pulse"></div>
            <div className="h-4 bg-gray-300 rounded w-full animate-pulse"></div>
            <div className="h-4 bg-gray-300 rounded w-5/6 animate-pulse"></div>
            <div className="h-4 bg-gray-300 rounded w-full animate-pulse"></div>
            <div className="h-4 bg-gray-300 rounded w-4/6 animate-pulse"></div>
          </div>
        ) : (
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-gray-700 text-sm sm:text-base md:text-lg leading-relaxed md:leading-loose text-justify mb-10"
          >
            {fullText}
          </motion.p>
        )}

        {/* 🔥 IMAGE SECTION */}
        <div className="relative w-full h-[250px] sm:h-[320px] md:h-[450px] overflow-hidden rounded-xl shadow-xl">
          {loading ? (
            // 🔥 IMAGE SKELETON
            <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-pulse" />
          ) : images.length === 0 ? (
            <div className="w-full h-full flex items-center justify-center bg-gray-200 text-gray-500">
              No images uploaded
            </div>
          ) : (
            <AnimatePresence mode="wait">
              <motion.img
                key={current}
                src={images[current]}
                initial={{ opacity: 0, scale: 1.1 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 1.1 }}
                transition={{ duration: 0.8 }}
                className="absolute w-full h-full object-cover"
              />
            </AnimatePresence>
          )}

          {/* Overlay */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
        </div>
      </section>

      {isPage && <Footer />}
    </div>
  );
}
